import React from 'react'

export const SearchBox = (props) => {
  return (
    <div className="col col-sm-4 ">
        <input value={props.value} onChange={(event) => props.setSearchValue(event.target.value)} placeholder='Type to search...' className='form-control'/>
    </div>
  )
}
